import jQuery from "jquery";
import "jquery.easing";
import Header from "./modules/Header";

const $ = jQuery;
window.jQuery = $;
window.$ = $;

import ImgLazyLoad from "./modules/img-lazy-load";
import InviewObj from "./modules/InviewObj";
import PageHome from "./modules/PageHome";
import SpMenu from "./modules/SpMenu";
import Router from "./modules/Router";
import ModalPlayer from "./modules/ModalPlayer";

console.log("METRO WEATHER start");

class MainApp {
  constructor() {
    this.$window = $(window);
    this.fxImgSet = [];
    this.imgLazyLoad = new ImgLazyLoad(this);
    this.header = new Header(this);
    this.spMenu = new SpMenu(this);
    this.pageApp = undefined;
    this.modalPlayer = new ModalPlayer();

    this.currentNamespace = $(".wrapper > div").attr("data-barba-namespace");

    /*
    $(document).on('keydown', (e) => {
      if(e.originalEvent.keyCode == 71) {
        if($('.Test').css('display') == 'none') {
          $('.Test').css('display', 'block');
        } else {
          $('.Test').css('display', 'none');
        }
      }
    });
    */

    /*
    if(!this.isTouchDevice()) {
    }
    */

    $(document).on("touchstart", "a, button, .Header", (e) => {
      $(e.currentTarget).attr("data-touch", "true");
    });

    $(document).on("mouseleave", "a, button, .Header", (e) => {
      $(e.currentTarget).removeAttr("data-touch");
    });

    this.scrollableElement = null;
    let firefox = navigator.userAgent.match(/Firefox\/([0-9]+)\./);
    if ("scrollingElement" in document) {
      this.scrollableElement = document.scrollingElement;
    } else if (
      /*@cc_on!@*/ false ||
      (!!window.MSInputMethodContext && !!document.documentMode)
    ) {
      this.scrollableElement = document.documentElement;
    } else if (firefox && parseInt(firefox[1]) <= 47) {
      this.scrollableElement = document.documentElement;
    } else {
      this.scrollableElement = document.body;
    }

    // this.router = new Router(this);

    $(".MenuListItemBtn--local").on("click", (e) => {
      if (this.currentNamespace == "home") {
        if ($(e.currentTarget).attr("data-target") == "windguardian") {
          this.scrollPage($(".Section--product").offset()["top"]);
        } else if ($(e.currentTarget).attr("data-target") == "windforesight") {
          this.scrollPage($(".Section--system").offset()["top"]);
        }
        return false;
      }
    });

    $(document).on("click", ".BtnLocalNav", (e) => {
      if ($(e.currentTarget).attr("data-target") == "windguardian") {
        this.scrollPage($(".Section--product").offset()["top"]);
      } else if ($(e.currentTarget).attr("data-target") == "windforesight") {
        this.scrollPage($(".Section--system").offset()["top"]);
      }
    });

    this.$window
      .on("resize", () => {
        this.onWindowResize();
      })
      .on("scroll", () => {
        this.onWindowScroll();
      });
    this.onWindowResize();

    // console.log("namespace", $(".wrapper > div").attr("data-barba-namespace"));
    this.initPageApp(this.currentNamespace);
  }
  destroy() {
    this.fxImgSet = null;
    this.imgLazyLoad.clear();

    if (this.pageApp != undefined) {
      this.pageApp.destroy();
      this.pageApp = null;
      this.pageApp = undefined;
    }
  }

  initPageApp(namespace) {
    this.spMenu.close();

    if (namespace == "home") {
      this.pageApp = new PageHome(this);
    }

    this.fxImgSet = [];
    this.findElement = $('div[data-barba="container"]');
    this.findElement.find(".InviewObj").each((i, e) => {
      this.fxImgSet.push(new InviewObj($(e)));
    });

    this.imgLazyLoad.init();
    this.header.setNamespace(namespace);

    this.onWindowResize();
  }

  isTouchDevice() {
    return "ontouchstart" in window || navigator.msPointerEnabled
      ? true
      : false;
  }

  scrollPage(val, isCancelTransition = false) {
    if (isCancelTransition) {
      $(this.scrollableElement).stop(false).scrollTop(val);
    } else {
      $(this.scrollableElement)
        .stop(false)
        .animate({ scrollTop: val }, 1200, "easeInOutExpo");
    }
  }

  onWindowResize() {
    this.windowWidth = this.$window.width();
    this.windowHeight = this.$window.height();

    if (this.pageApp != undefined) {
      this.pageApp.onWindowResize();
    }

    this.onWindowScroll();
  }

  onWindowScroll() {
    this.scrollTop = this.$window.scrollTop();
    if (this.pageApp != undefined) {
      this.pageApp.onWindowScroll(this.scrollTop);
    }
    this.imgLazyLoad.update(this.scrollTop, this.windowHeight);

    if (this.fxImgSet) {
      for (let i = 0; i < this.fxImgSet.length; i++) {
        this.fxImgSet[i].update(this.scrollTop, this.windowHeight);
      }
    }
  }
}

$("document").ready(() => {
  new MainApp();
  $(".Header").delay(500).css("opacity", 1);
});

$(window).on("load", () => {
  // $('.Header').delay(500).css('opacity', 1);
  // window.onLoadComplete = true;
});
